<template>
  <div style="position: fixed; z-index: 110; top: 25px; right: 10px; opacity: 0.05">
    <v-switch inset v-model="dev_check" />
  </div>
  <div v-if="canDraw && report_data" style="background: #e8e8e8; position: fixed; top: 20px; left: 0; width: 100%; height: 100%; z-index: 100; overflow: auto;">
    <v-img v-if="hasExecImage" :src="getExecutorImage()" id="exec_logo" @load="checkLoad()" style="max-width: 300px" />
    <div v-if="converted" style="margin-top: 10px;">
      <div v-for="page in converted.pages" :key="page">
        <div class="d-flex justify-center align-center">
          <v-chip density="compact" class="ma-5">Шаблон: {{page.pattern}}</v-chip>
        </div>
        <div v-for="(report, index) in page.reports" :key="report.guid">
          <ChartHandler mode="print" :pattern="page.pattern" :current="report" :index="index"/>
        </div>
      </div>
    </div>
  </div>

  <div v-if="dev_check && converted && report_data" style="background: #ffffff; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 100">
    <ColoredBG type="default" />
    <div class="contented d-flex align-center justify-space-around" style="height: 100%">
      <div>
        <v-card style="min-width: 400px" :color="`#f6f6f6`" flat rounded="xl">
          <template v-slot:title>
            <div class="d-flex align-center justify-center">
              <v-img v-if="hasLogoImage" :src="getContractImage()" id="cont_logo"  @load="checkLoad()" style="max-width: 200px" />
            </div>
          </template>

          <template v-slot:text>
            <div class="d-flex"><strong>Договор</strong><v-spacer />{{ report_data['Объект'] }}</div>
            <div class="d-flex"><strong>Заказчик</strong><v-spacer />{{ report_data['Заказчик'] }}</div>
            <div class="d-flex"><strong>Исполнитель</strong><v-spacer />{{ report_data['organization'] }}</div>
            <div class="d-flex"><strong>Отчётный период</strong><v-spacer />с {{ moment(range.start).format('DD.MM.YYYY') }} по {{ moment(range.end).format('DD.MM.YYYY') }}</div>
            <div class="d-flex"><strong>Кол-во стр.</strong><v-spacer />{{ pageList.length }}</div>

            <v-sheet color="white" v-if="final_errors" rounded="xl">
              <v-sheet class="pa-2 text-center mt-2" color="deep-orange" rounded="xl">ВНИМАНИЕ</v-sheet>
              <v-sheet color="transparent" class="pa-2">
                <p v-for="error in final_errors" :key="error">
                  {{ error }}
                </p>
              </v-sheet>
            </v-sheet>

            <v-divider v-if="report_data && inProgress" class="mx-0 my-2"/>

            <div v-if="report_data && inProgress" class="d-flex align-center">
              <span v-if="progress === pageList.length">ПОДГОТОВКА К ЗАГРУЗКЕ</span>
              <span v-else>ИДЁТ ПОСТРОЕНИЕ ОТЧЁТА</span>
            </div>
            <v-progress-linear
                stream
                rounded
                :color="progress === pageList.length ? 'light-green' : 'deep-orange'"
                :height="20"
                :max="pageList.length"
                v-model="progress"
                v-if="report_data && inProgress"
            >
              <div class="special-progress-text" v-if="progress !== pageList.length">{{ now_printing }}</div>
            </v-progress-linear>


          </template>
          <template v-slot:actions v-if="report_data && !inProgress" >
            <v-row>
              <v-col>
                <v-tooltip text="НАЗАД">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" class="ma-2" v-on:click="goBack()" :icon="['fas', 'chevron-left']" variant="text" density="compact">
                      <v-icon :icon="['fas', 'chevron-left']" />
                    </v-btn>
                  </template>
                </v-tooltip>
                <v-tooltip text="НОВЫЙ ОТЧЁТ">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" class="ma-2" variant="text" :icon="['fas', 'plus']" v-on:click="createNew()" density="compact">
                      <v-icon :icon="['fas', 'plus']" />
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-btn v-on:click="printReport()" class="ma-2">
                  ПЕЧАТЬ
                  <template v-slot:append>
                    <v-icon :icon="['fas', 'print']" />
                  </template>
                </v-btn>
              </v-col>
              <v-col style="text-align: end">

              </v-col>
            </v-row>
          </template>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ReportData } from "@/store/report/ReportData";
import { Rep_Contract, Rep_Period, Rep_Step } from "@/store/report/SmallStorrage";
import { jsPDF } from 'jspdf'
import html2canvas from "html2canvas";
import ColoredBG from "@/components/Style/ColoredBG.vue";
import ChartHandler from "@/components/Reports/ChartHandler.vue";
import randomstring from "randomstring";
import moment from "moment";
import { CheckReport } from "@/libs/report_checker";

export default {
  name: "reportShow",
  components: { ChartHandler, ColoredBG },
  async beforeMount() {
    if (!this.report_data) {
      Rep_Step().set(0)
      this.$router.push({name: 'report__create'})
    } else {
      await this.prepareData()
    }
  },
  data() {
    return {
      status: null,
      dev_check: true,
      pages: {
        current: 0
      },
      now_printing: null,
      progress: 0,
      converted: {},
      canDraw: false,
      inProgress: false,
      // ФЛАГ : Наличие изображения стороны заказчика
      hasLogoImage: true,
      srcLogoImage: null,
      hasExecImage: true,
      srcExecImage: null,
      // СЧЁТЧИК : Счётчик страниц
      curr_page: 1,
      // ОБЪЕКТ : Текущий файл PDF
      pdf: new jsPDF({
        orientation: 'l',
        unit: 'mm',
        format: [297, 210]
      })
    }
  },
  computed: {
    final_errors() {
      let errors = []

      if (!this.report_data.report_agreement) {
        errors.push('Отсутствует согласовавший!')
      }

      if (!this.report_data.report_author) {
        errors.push('Отсутствует автор!')
      }

      if (!this.report_data.report_accept) {
        errors.push('Утверждающее лицо не указано')
      }

      if (!this.report_data.report_check) {
        errors.push('Ответственное лицо за проверку не указано!')
      }

        if (errors.length > 0) {
          return errors
        } else {
          return null
        }
    },
    normal_date() {
      return date => {
        return moment(date).utcOffset(false).format("DD.MM.YYYY")
      }
    },
    /** Переменная, возвращающая массив страниц **/
    pageList() {
      let ret = []
      for (let section of this.report_data.section_list) {
        for (let page of section.groups) {
          if (this.prepareReports(page.reports).length > 0) {
            ret.push(page.guid)
          }
        }
      }
      return ret
    },
    /** Переменная, хранящая в себе GUID текущего выбранного контракта **/
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    /** Переменная, хранящая в себе сортированный массив всех отчётов, страниц и разделов **/
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  },
  methods: {
    moment,
    // РАЗДЕЛ 1: Общие функции
    /** Функция проверки наличия изображения стороны заказчика
     *
     *  В случае, если изображение есть - возвращается ссылка на изображение,
     *  в противном случае - возвращаеися NULL, и изображение не отрисовывается.
     *
     *  Флаг "hasLogoImage" - используется далее по коду, для условного исполнения кода.
     *  (Отвечает за наличие изображения стороны заказчика)
     *
     * **/
    getContractImage: function () {
      let image
      try {
        image = require(`@/components/Reports/images/reports/contracts/${this.contract}.png`)
      } catch (err) {
        this.hasLogoImage = false
        console.log(`%cВыбранный контракт не имеет загруженного логотипа!\n\n%c${this.contract}.png`, 'background: #f00; color: #fff', 'background: transparent; color: #000')
      }
      if (image) {
        this.hasLogoImage = true
        this.srcLogoImage = image
      }

      if (this.hasLogoImage) return image
      return null
    },

    getExecutorImage: function () {
      let image
      try {
        image = require(`@/components/Reports/images/reports/executors/${this.report_data.organization_GUID}.png`)
      } catch (err) {
        this.hasExecImage = false
        console.log(`%cИсполнитель по договору не имеет загруженного логотипа!\n\n%c${this.report_data.organization_GUID}.png`, 'background: #f00; color: #fff', 'background: transparent; color: #000')
      }
      if (image) {
        this.hasExecImage = true
        this.srcExecImage = image
      }

      if (this.hasExecImage) return image
      return null
    },
    /** Функция (Вспомогательная), исполняющая код при успешной загрузке изображения
     * В текущей версии - отправляет сообщение в консоль об успешной загрузке
     * **/
    checkLoad: function () {
      //console.log(`%cЛоготип контракта успешно загружен!`, 'background: #222; color: #61e256')
    },
    /** Функция (Навигационная), перенаправляющая в редактор
     * **/
    goBack: function () {
      this.$router.push({ path: '/report/editor' })
    },
    /** Функция (Навигационная), перенаправляющая к созданию нового отчёта
     * **/
    createNew: function () {
      this.report_data = null
      this.clearContract()
      this.$router.push({ path: '/report/create' })
    },
    clearDate: function () {
      this.range = null
    },
    clearContract: function () {
      this.contract = ''
      this.clearDate()
    },
    getImage: function (type) {
      switch (type) {
        case 'contractor':
          if (this.hasLogoImage) {
            return {
              status: true,
              url: this.getContractImage()
            }
          } else {
            return {
              status: false
            }
          }
        case 'executor':
        default:
          return {
            status: false
          }
      }
    },
    getPattern: function(reports) {
      let description = this.generateDescriptionString(reports)
      let legend = {
        status: false,
        position: null
      }
      for (let [index, report] of reports.entries()) {
        let tmp = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
        if (tmp.legend) {
          legend = {
            status: true,
            position: index
          }
        }
      }
      switch (reports.length) {
        case 0:
          return 'empty'
        case 1:
          if (this.$rep_cfg.patterns.find(pattern => pattern.name === 'multipage').charts.includes(reports[0].report_guid)) {
            return 'multipage_empty'
          } else if (legend.status === true && description !== false) {
            return 'single_legend-note'
          } else if (legend.status === true && description === false) {
            return 'single_legend'
          } else if (legend.status === false && description !== false) {
            return 'single_note'
          } else {
            return 'single_empty'
          }
        case 2:
          if (legend.status === true && description !== false) {
            return 'double_legend-note'
          } else if (legend.status === true && description === false) {
            return 'double_legend'
          } else if (legend.status === false && description !== false) {
            return 'double_note'
          } else {
            return 'double_empty'
          }
        case 3:
          if (description !== false) {
            return 'triple_note'
          } else {
            return 'triple_empty'
          }
        default:
          return 'empty'
      }
    },

    // РАЗДЕЛ 2: Функции, отвечающие за отрисовку отчёта в PDF
    /** Функция (Главная) подготовки данных для отрисовки.
     * **/
    prepareData: async function () {
      let prepared_data = {
        title: {
          name: this.report_data['Заказчик'],
          subname: '',
          approval_list: {
            agreement: this.report_data.report_agreement ? this.report_data.report_agreement : null,
            acception: this.report_data.report_accept ? this.report_data.report_accept : null,
            author: this.report_data.report_author ? this.report_data.report_author : null,
            check: this.report_data.report_check ? this.report_data.report_check : null
          },
          period: {
            start: this.normal_date(this.range.start),
            finish: this.normal_date(this.range.end)
          },
          date: new Date().toLocaleDateString(),
          media: {
            contractor: this.getImage('contractor'),
            executor: this.getImage('executor'),
          }
        },
        pages: []
      }
      for (let sector of this.report_data.section_list) {
        for (let page of sector.groups) {
          let reports = await this.prepareReports(page.reports)
          if (reports.length > 0) {
            let tmp_data = {
              position: page.page,
              guid: page.guid,
              pattern: this.getPattern(reports),
              sector: sector.name,
              description: this.generateDescriptionString(reports),
              reports: this.generateReportsOnPage(reports)
            }
            prepared_data.pages.push(tmp_data)
          }
        }
      }
      this.converted = prepared_data
      this.canDraw = true
    },
    prepareReports: function (reports) {
      let reps = reports.filter(report => {
        return CheckReport(report)
      })
      return reps
    },
    CheckObject: function (element) {
      const chart = this.$rep_cfg.charts.find(el => el.guid === element['report_guid'])
      if (chart && chart.has_objects) return true
      return false
    },
    generateReportsOnPage: function (reports) {
      let data = []
      for (let report of reports) {
        let tmp = this.$rep_cfg.charts.find(chart => chart.guid === report.report_guid)
        data.push({
          uuid: this.generateUUID(report.report_guid),
          guid: report.report_guid,
          name: this.CheckObject(report) ? report.report_description + ' ' + (report.report_data.length > 0 && report.report_data[0] && Object.keys(report.report_data[0]).includes('ФизОбъектПРЕДСТАВЛЕНИЕ') ? report.report_data[0]['ФизОбъектПРЕДСТАВЛЕНИЕ'] : null) : report.report_description,
          scale: tmp.needSpace,
          legend: tmp.legend,
          raw_data: report
        })
      }
      return data
    },
    generateUUID: function (guid) {
      return guid+'_'+randomstring.generate(16)
    },
    /** Функция генерации составной пояснительной записки.
     * **/
    generateDescriptionString: function (reports) {
      let note = ''
      let has_note = false
      // Один отчёт в группе
      for (let report of reports) {
        if (report.description_note) {
          has_note = true
        }
      }

      if (has_note) {
        if (reports.length > 1) {
          for (let [index, report] of reports.entries()) {
            if (report.description_note) {
              if (index > 0) {
                note += '\n'
              }
              note+=`Пояснительная записка к ${index+1} графику:`
              note+='\n'
              note+=report.description_note
            }
          }
        } else if (reports.length === 1) {
          note+=`Пояснительная записка:\n`
          note+=reports[0].description_note
        }
        return note
      } else {
        return false
      }
    },
    /** Функция (Главная) отрисовки отчёта в PDF.
     *
     * Включает в себя набор следуюих функций:
     * 1. Функция отрисовки титульного листа
     * 2. Функцию перебора по страницам и отрисовки страниц
     * 3. Функцию отрисовки последней страницы
     *
     * **/
    printReport: async function () {
      this.progress = 0
      this.inProgress = true
      await this.printTitlePage()

      for (let [index, page] of this.converted.pages.entries()) {
        await this.renderCurrentPage(page)
        if (this.converted.pages.length !== index) {
          await this.addNewPage()
        }
        this.progress++
      }
      await this.save_pdf()
    },
    /** Функция отрисовки титульной страницы
     *
     *  1. Генерация логотипов
     *  2. Генерация ответственных лиц
     *  3. Генерация заголовка титульного листа
     *  4. Генерация дат и вспомогательной информации
     *
     * **/
    printTitlePage: async function () {
      this.now_printing = `Титульная страница`
      console.log(`%cОтрисовываю титульный лист...`, 'background: #222; color: #f9dc30;')
      await this.renderTitlePageLogotypes()
      await this.renderTitlePagePplz()
      await this.renderTitleText()
      console.log(`%cТитульный лист успешно отрисован!`, 'background: #222; color: #61e256')
      await this.addNewPage()
    },
    /**
     *
     * Функция генерации изображения стороны заказчика на титульном листе
     *
     * **/
    renderTitlePageLogotypes() {
      this.now_printing = `Титульная страница: Логотипы`
      console.log(`%cОтрисовываю логотипы...`, 'background: #222; color: #f9dc30')
      if (this.hasLogoImage) {
        let image = new Image()
        let max_width = 80
        let height = 20
        let width = ((image.width / image.height) * height)
        image.src = require(`@/components/Reports/images/reports/contracts/${this.contract}.png`)

        if (height * 2 < width) {
          width = 80
          height = (width / (image.width / image.height))
        } else {
          height = 20
          width = ((image.width / image.height) * height)
        }

        if (width > max_width) {
          width = max_width
          height = (width / (image.width / image.height))
        }

        this.pdf.addImage(image, 'png', (297-10-width), 10, width, height)
        console.log(`%cЛоготип стороны заказчика успешно отрисован!`, 'background: #222; color: #61e256')
      } else {
        console.log(`%cЛоготип стороны заказчика отсутствует на титульном листе, по причине его отсутствия!`, 'background: #f00; color: #fff')
      }

      if (this.hasExecImage) {
        let image = new Image()
        let max_width = 80
        let height = 20
        let width = ((image.width / image.height) * height)
        image.src = require(`@/components/Reports/images/reports/executors/${this.report_data.organization_GUID}.png`)

        if (height * 2 < width) {
          width = 80
          height = (width / (image.width / image.height))
        } else {
          height = 20
          width = ((image.width / image.height) * height)
        }

        if (width > max_width) {
          width = max_width
          height = (width / (image.width / image.height))
        }


        this.pdf.addImage(image, 'png', 10, 10, width, height)
        console.log(`%cЛоготип исполнителя успешно отрисован!`, 'background: #222; color: #61e256')
      } else {
        console.log(`%cЛоготип исполнителя отсутствует на титульном листе, по причине его отсутствия!`, 'background: #f00; color: #fff')
      }
    },
    renderTitlePagePplz: async function () {
      this.now_printing = `Титульная страница: Согласующие`
      this.pdf.setFont('DinCyRg')
      this.pdf.setFontSize(14)

      if (this.converted.title.approval_list.agreement) {
        // Agreement
        this.pdf.text('Согласовал', 10, 50, 'left')
        this.pdf.text('_________________ / ' + this.converted.title.approval_list.agreement, 10, 58, 'left')
      }

      if ( this.converted.title.approval_list.acception) {
        // Accepted
        this.pdf.text('Утвердил', 287, 50, 'right')
        this.pdf.text('_________________ / ' + this.converted.title.approval_list.acception, 287, 58, 'right')
      }

      if (this.converted.title.approval_list.author) {
        // Author
        this.pdf.text('Автор', 10, 72, 'left')
        this.pdf.text('_________________ / ' + this.converted.title.approval_list.author, 10, 80, 'left')
      }

      if (this.converted.title.approval_list.check) {
        // Checker
        this.pdf.text('Проверил', 287, 72, 'right')
        this.pdf.text('_________________ / ' + this.converted.title.approval_list.check, 287, 80, 'right')
      }
    },
    renderTitleText: async function() {
      this.now_printing = `Титульная страница: Название отчёта`
      let tmp = []
      let has_external = false
      let array = [
        'ОТЧЁТ',
        this.report_data.organization,
        'по договору '+this.converted.title.name,
        `за период c ${moment(this.range.start).format('DD.MM.YYYY')} по ${moment(this.range.end).format('DD.MM.YYYY')}`
      ]
      for (let i = 0; i < array.length; i++) {
        if (array[i] !== '') {
          if (!(array[i].length > 70)) {
            tmp.push(array[i])
          } else {
            let strokes = this.pdf.splitTextToSize(array[i], 200)
            tmp.push(strokes)
            has_external = true
          }
        }
      }
      array = tmp
      for (let i = 0; i < array.length; i++) {
        this.pdf.setFontSize(20)
        this.pdf.setFont('DinCyBd')
        if (i === 3 && has_external) {
          this.pdf.text(array[i], 150, 95+(i*8)+8, 'center')
        } else {
          this.pdf.text(array[i], 150, 95+(i*8), 'center')
        }
      }
    },
    renderCurrentPage: async function (page) {
      this.now_printing = `Страница: ${page.position}`
      let scales = this.getPatternByName(page.pattern).locations
      if (scales === 'empty')  {
        // ЧОта не то
      } else {
        await this.printPageTitle(page)
        let pattorn = page.pattern.split('_')
        switch (pattorn[0]) {
          case 'single':
            await this.printSingleChart(page, scales)
            break;
          case 'double':
            await this.printDoubleChart(page, scales)
            break;
          case 'triple':
            await this.printTripleChart(page, scales)
            break;
          case 'multipage':
            await this.printMultipageChart(page, scales)
            break;
          default:
            console.log('Ошибка выбора шаблона')
            break;
        }
      }
    },
    getPatternByName: function (current) {
      let patt = current.split('_')
      if (patt[0] === 'empty') {
        return {
          locations: 'empty'
        }
      } else {
        let pattern = (this.$rep_cfg.patterns.find(pattern => pattern.name === patt[0])).modifications.find(mod => mod.name === patt[1])
        return pattern
      }
    },
    printDescriptionNote: async function (scales, description) {
      // SINGLE | DOUBLE
      this.pdf.setFont('DinCyRg')
      this.pdf.setFontSize(14)
      let rows = description.replaceAll('\n', '\n‎')
      rows = rows.split('\n')
      let tmp_rows = []
      for (let line of rows) {
        tmp_rows.push(this.pdf.splitTextToSize(line, scales.note.w))
      }
      rows = tmp_rows.flat(1)

/*
░░░░░░░░░░░░░░░░░░░░
░ВЗГЛЯНИ ░░ВОКРУГ,░░░░░
░ОГЛЯНИСЬ░НАЗАД!░░░░░░
░ГУСИ░▄▀▀▀▄░С░ТОБОЮ░░
░░░░▀░░░◐░▀███▄░░░░░
░░░░▌░░░░░▐░░░░░░░░░
░░░░▐░░░░░▐░░░░░░░░░
░░░░▌░░░░░▐▄▄░░░░░░░
░░░░▌░░░░▄▀▒▒▀▀▀▀▄
░░░▐░░░░▐▒▒▒▒▒▒▒▒▀▀▄
░░░▐░░░░▐▄▒▒▒▒▒▒▒▒▒▒▀▄
░░░░▀▄░░░░▀▄▒▒▒▒▒▒▒▒▒▒▀▄
░░░░░░▀▄▄▄▄▄█▄▄▄▄▄▄▄▄▄▄▄▀▄
░СВЯЗАТЬСЯ░░▌▌░▌▌░░░░░
░░░ХОТЯТ░░░░▌▌░▌▌░░░░░
░░░░░░░░░░░▄▄▌▌▄▌▌░░
*/

      if (rows.length < scales.note.lines) {
        for (let [index, row] of rows.entries()) {
          this.pdf.text(row, scales.note.x, scales.note.y + (5 * index), 'left')
        }
      } else {
        for (let i = 0; i < scales.note.lines; i++) {
          this.pdf.text(rows[i], scales.note.x, scales.note.y + (5 * i), 'left')
        }
        // 35 строк на 1 страницу входит
        // Расчитываем, сколько строк будет на полных страницах документа
        let new_description = []
        for (let i = scales.note.lines; i < rows.length; i++) {
          if (rows[i] !== '') {
            new_description.push(rows[i])
            //new_description = new_description.concat(this.pdf.splitTextToSize(rows[i], 277))
          } else {
            new_description.push('\n')
          }
        }
        let tp = new_description.join(' ')
        new_description = []
        tp.split('‎').forEach(line => {
          new_description = new_description.concat(this.pdf.splitTextToSize(line, 277))
        })
        rows = new_description

        let pages = Math.ceil(rows.length / 35)
        for (let i = 0; i < pages; i++) {
          await this.addNewPage()
          let local_line = 0
          for (let j = i*35; j < (i+1)*35; j++) {
            if (rows[j]) {
              this.pdf.setFont('DinCyRg')
              this.pdf.setFontSize(14)
              this.pdf.text(rows[j], 10, 10 + (5 * local_line), 'left')
              local_line++
            }
          }
        }
      }
    },
    printSingleChart: async function (page, scales) {
      for (let [index, report] of page.reports.entries()) {
        await this.printChartTitle(scales.charts[index].title, `${report.name}`)
        this.now_printing = `Стр. ${page.position} - 1 на 1: ${report.guid}`
        let image = document.getElementById(report.uuid)
        await html2canvas(image, {
          dpi: 1000,
          scale: 2
        }).then((canvas) => {
          let img = canvas.toDataURL("image/jpeg", 2);
          this.pdf.addImage(img, 'JPEG', scales.charts[index].chart.x, scales.charts[index].chart.y, scales.charts[index].chart.w, scales.charts[index].chart.h)
        })

        if (report.legend) {
          let legend = document.getElementById(report.uuid+'_legend')
          await html2canvas(legend, {
            dpi: 1000,
            scale: 2
          }).then((canvas) => {
            let img = canvas.toDataURL("image/jpeg", 2);
            this.pdf.addImage(img, 'JPEG', scales.charts[index].legend.x, scales.charts[index].legend.y, scales.charts[index].legend.w, scales.charts[index].legend.w / legend.offsetWidth * legend.offsetHeight)
          })
        }

        if (page.description) {
          await this.printDescriptionNote(scales, page.description)
        }
      }
    },
    printDoubleChart: async function (page, scales) {
      let legend_massive = [false, false]
      for (let [index, report] of page.reports.entries()) {
        if (report.legend) {
          legend_massive[index] = true
        }
      }
      if (legend_massive.includes(true)) {
        if (legend_massive[0] !== true) {
          page.reports.reverse()
        }
      }

      for (let [index, report] of page.reports.entries()) {
        this.now_printing = `Стр. ${page.position} - 2на1: ${report.guid}`
        let image = document.getElementById(report.uuid)
        await this.printChartTitle(scales.charts[index].title, `${report.name}`)
        await html2canvas(image, {
          dpi: 1000,
          scale: 2
        }).then((canvas) => {
          let img = canvas.toDataURL("image/jpeg", 2);
          this.pdf.addImage(img, 'JPEG', scales.charts[index].chart.x, scales.charts[index].chart.y, scales.charts[index].chart.w, scales.charts[index].chart.h)
        })

        if (report.legend) {
          let legend = document.getElementById(report.uuid+'_legend')
          await html2canvas(legend, {
            dpi: 1000,
            scale: 2
          }).then((canvas) => {
            let img = canvas.toDataURL("image/jpeg", 2);
            this.pdf.addImage(img, 'JPEG', scales.charts[index].legend.x, scales.charts[index].legend.y, scales.charts[index].legend.w, scales.charts[index].legend.w / legend.offsetWidth * legend.offsetHeight)
          })
        }
      }
      if (page.description) {
        await this.printDescriptionNote(scales, page.description)
      }
    },
    printTripleChart: async function (page, scales) {
      for (let [index, report] of page.reports.entries()) {
        this.now_printing = `Стр. ${page.position} - 3на1: ${report.guid}`
        let image = document.getElementById(report.uuid)
        let local_scales = scales.charts[index]

        await this.printChartTitle(local_scales.title, `${report.name}`)
        await html2canvas(image, {
          dpi: 1000,
          scale: 2
        }).then((canvas) => {
          let img = canvas.toDataURL("image/jpeg", 2);
          this.pdf.addImage(img, 'JPEG', local_scales.chart.x, local_scales.chart.y, local_scales.chart.w, local_scales.chart.h)
        })

        if (report.legend) {
          let legend = document.getElementById(report.uuid+'_legend')
          await html2canvas(legend, {
            dpi: 1000,
            scale: 2
          }).then((canvas) => {
            let img = canvas.toDataURL("image/jpeg", 2);
            this.pdf.addImage(img, 'JPEG', local_scales.legend.x, local_scales.legend.y, local_scales.legend.w, local_scales.legend.w / legend.offsetWidth * legend.offsetHeight)
          })
        }
      }
      if (page.description) {
        await this.printDescriptionNote(scales, page.description)
      }
    },
    printMultipageChart: async function (page, scales) {
      await this.printChartTitle(scales.charts[0].title, `${page.reports[0].name}`)
      this.now_printing = `Стр. ${page.position} - млт.: ${page.reports[0].guid}`
      let ctx = document.getElementsByClassName(page.reports[0].uuid)
      let legus = page.reports[0].legend
      if (page.reports[0].legend) {
        let legend = document.getElementById(page.reports[0].uuid+'_legend')
        await html2canvas(legend, {
          dpi: 1000,
          scale: 2
        }).then((canvas) => {
          let img = canvas.toDataURL("image/jpeg", 2);
          this.pdf.addImage(img, 'JPEG', scales.charts[0].legend.x, scales.charts[0].legend.y, scales.charts[0].legend.w, scales.charts[0].legend.w / legend.offsetWidth * legend.offsetHeight)
        })
      }

      let id_list = []
      for (let canvas of ctx) {
        console.log(canvas)
        id_list.push(canvas.id)
      }

      let as = scales.available_space.h
      let from_top = scales.available_space.y

      for (let chart_id of id_list) {
        this.now_printing = `Стр. ${page.position} - млт.: ${page.reports[0].guid} - ${id_list.indexOf(chart_id) + 1}`
        let current_chart = document.getElementById(chart_id)
        let chart_height_mm = Math.ceil(scales.charts[0].chart.w / (current_chart.offsetWidth / current_chart.offsetHeight))
        let chart_width_mm = scales.charts[0].chart.w

        if (as < chart_height_mm) {
          await this.addNewPage()
          legus = false
          as = 180
          from_top = 5
        }

        await html2canvas(current_chart, {
          dpi: 1000,
          scale: 2
        }).then((canvas) => {
          let img = canvas.toDataURL("image/jpeg", 2);
          this.pdf.addImage(img, 'JPEG', scales.available_space.x, from_top, chart_width_mm, chart_height_mm)
        })

        from_top = from_top+chart_height_mm
        as = as-chart_height_mm
      }

      if (page.description) {
        if (from_top + 10 < 180) {
          from_top = from_top + 10
        } else {
          await this.addNewPage()
          legus = false
          from_top = 10
        }

        this.pdf.setFont('DinCyRg')
        this.pdf.setFontSize(14)
        let rows = page.description.replace('\n', '\n‎')
        rows = rows.split('\n')
        let tmp_rows = []
        for (let line of rows) {
          tmp_rows = tmp_rows.concat(this.pdf.splitTextToSize(line, legus ? scales.charts[0].chart.w : 277))
        }

        rows = tmp_rows

        console.log(`Отступ сверху: ${from_top}`)

        let free_space_to_note = 175 - from_top

        if (free_space_to_note >= (5 * rows.length)) {
          console.log('Строки влазиют на стр')
          for (let [index, row] of rows.entries()) {
            this.pdf.text(row, 10, from_top + (5 * index), 'left')
          }
        } else {
          console.warn(free_space_to_note)
          let lines = Math.floor(free_space_to_note / 5)
          for (let i = 0; i < lines; i++) {
            this.pdf.text(rows[i], 10, from_top + (5 * i), 'left')
          }
          // 35 строк на 1 страницу входит
          // Расчитываем, сколько строк будет на полных страницах документа
          let new_description = []
          console.log(lines)
          for (let i = lines; i < rows.length; i++) {
            if (rows[i] !== '') {
              new_description.push(rows[i])
              //new_description = new_description.concat(this.pdf.splitTextToSize(rows[i], 277))
            } else {
              new_description.push('\n')
            }
          }

          let desc_str = ''
          for (let i = 0; i < new_description.length; i++) {
            desc_str += new_description[i]
          }
          new_description = this.pdf.splitTextToSize(desc_str, 277)
          rows = new_description
          let pages = Math.ceil(rows.length / 35)
          for (let i = 0; i < pages; i++) {
            await this.addNewPage()
            let local_line = 0
            for (let j = i*35; j < (i+1)*35; j++) {
              if (rows[j]) {
                this.pdf.setFont('DinCyRg')
                this.pdf.setFontSize(14)
                this.pdf.text(rows[j], 10, 10 + (5 * local_line), 'left')
                local_line++
              }
            }
          }
        }
      }
    },
    printChartTitle: async function (scales, text) {
      this.pdf.setFont('DinCyRg')
      this.pdf.setFontSize(14)
      let rows = []
      rows.push(this.pdf.splitTextToSize(text, scales.w))
      for (let [index, line] of rows.entries()) {
        this.pdf.text(line, scales.x, scales.y*(index+1), 'left')
      }
    },
    printPageTitle: async function(page) {
      this.now_printing = `Страница ${page.position}: Название раздела`
      this.pdf.setFont('DinCyBd')
      this.pdf.setFontSize(14)
      this.pdf.text(`${page.sector}`, 10, 10, 'left')
    },
    printPageColumnTitle: async function() {
      // ГЕНЕРИРУЕМ ПОЛОСОЧКИ КОЛОНТИТУЛА
      this.pdf.setDrawColor(83,83,82)
      this.pdf.setLineWidth(0.5)
      this.pdf.line (0, 185, 297, 185)
      this.pdf.setLineWidth(1.5)
      this.pdf.line (0, 187, 297, 187)

      // ГЕНЕРИРУЕМ подпись страницы
      this.pdf.setFont('DinCyRg')
      this.pdf.setFontSize(8)
      this.pdf.text('Отчёт за период с '+this.converted.title.period.start+' по '+this.converted.title.period.finish, 10, 195)

      this.pdf.setFontSize(12)
      this.pdf.text('Стр.'+this.pages.current, 10, 201)

      this.pdf.setFontSize(8)
      this.pdf.text(`${this.$rep_cfg.metadata.company}`, 285, 195, 'right')
      this.pdf.text(`Тел.: ${this.$rep_cfg.metadata.phone}`, 285, 198, 'right')
      this.pdf.text(this.$rep_cfg.metadata.webpage, 285, 201, 'right')
    },
    /*printNew: function () {
      let printable_data = {}
      printable_data['pages__report'] = []
      printable_data['pages__title'] = []

      printable_data['pages__title'].push({
        guid: 'title_page',
        title: this.report_data['Объект'],
        data: {
          images: {
            left: null,
            right: null
          },
          dates: {
            period: null
          },
          persons: {
            acceptor: this.report_data.report_accept,
            agreemer: this.report_data.report_agreement,
            author: this.report_data.report_author,
            checker: this.report_data.report_check,
          }
        }
      })
      for (let section of this.report_data.section_list) {
        for (let page of section.groups) {
          printable_data['pages__report'].push({
            guid: page.guid,
            title: section.name,
            data: generateReports(page.reports),
            colontitle: {
              page: page.page,
              period: null,
              company_name: 'ООО "ИТЦ"Гардиан"',
              company_phone: 'ООО "ИТЦ"Гардиан"',
              company_cite: 'www.scgrdn.ru'
            },
          })
        }
      }
      function generateReports(reports) {
        let array = []
        let template = reports.length
        let to_push
        switch (template) {
          case 1:
            to_push = {
              subtitle: reports[0].report_description,
              graph: {
                img: getGraph(reports[0]),
                position: null
              },
              note: {
                text: null,
                position: null
              }
            }
            array.push(to_push)
            break
        }
        function getGraph(report) {
          let ctx = document.querySelectorAll(`[id^="${report.id}"]`)
          let tmp_id = report.id.split('_')
          for (let dom of ctx) {
            let tmp = dom.id.split('_')
            if (tmp[0] === tmp_id[0] && tmp[1] === tmp_id[1]) {
              ctx = dom
            }
          }
          return ctx
        }
      }
    },*/
    addNewPage: async function () {
      this.pages.current++
      await this.pdf.addPage()
      await this.printPageColumnTitle()
      await this.clearCounters()
    },
    add_text: function (text, x, y, align, font, size) {
      this.pdf.setFont(font)
      this.pdf.setFontSize(size)
      this.pdf.text(text, x, y, align)
      this.counters.from_top.current += size/2
    },
    print: async function () {
      await this.gen_1_page()
      await this.gen_pages()
      await this.save_pdf()
    },
    gen_1_page: async function () {
      await this.gen_title_images()
      await this.gen_title_text()
      await this.addNewPage()
    },
    gen_title_images: async function () {
      await this.gen_title_image('left')
      await this.gen_title_image('right')
    },
    gen_title_image: async function (position) {
      switch (position) {
        case 'left':
          break;
        case 'right':
          break;
      }
    },
    gen_reports: async function (page) {
      const pattern = page.reports.length
      await this.gen_report(page.reports, pattern)
      console.log(`%c\nСохраняю размеры графика в общую высоту СТР.\n${this.counters.from_top.graph_height}\n${this.counters.from_top.current}\n`, 'background: #dddddd; color: #ff0000')
      this.counters.from_top.current += this.counters.from_top.graph_height
      console.log(`%cСуммарная высота: ${this.counters.from_top.current}`, 'background: #dddddd; color: #ff0000')
    },
    gen_report: async function (report_data, pattern) {
      switch (pattern) {
        case 1:
          await this.gen_report_single(report_data)
          break
        case 2:
          await this.gen_report_double(report_data)
          break
        case 3:
          await this.gen_report_triple(report_data)
          break
      }
    },
    gen_long_text: function (data, len, x, y, align, font, size) {
      let strokes = this.pdf.splitTextToSize(data, len)
      for (let i = 0; i < strokes.length; i++) {
        this.add_text(strokes[i], x, y+(i*(size/2)), align, font, size)
      }
    },
    check_notes: function (reports) {
      for (let report of reports) {
        if (report.description_note && report.description_note !== '') {
          return true
        }
      }
      return false
    },
    gen_report_single: async function (data) {
      let ctx = document.querySelectorAll(`[id^="${data[0].id}"]`)
      let tmp_id = data[0].id.split('_')
      for (let dom of ctx) {
        let tmp = dom.id.split('_')
        if (tmp[0] === tmp_id[0] && tmp[1] === tmp_id[1]) {
          ctx = dom
        }
      }
      if(ctx) {
        await html2canvas(ctx, {
          dpi: 1000,
          scale: 1
        }).then((canvas) => {
          let img = canvas.toDataURL("image/png", 2);
          if (this.check_notes(data)) {
            this.add_image(img, 'a4_p1_desc', 10, this.counters.from_top.current)
          } else {
            this.add_image(img, 'a4_p1', 10, this.counters.from_top.current)
          }
          this.status = ((data[0].id).split('_')[1] / this.pageList.length * 100).toFixed(2)
        })
      }
    },
    gen_report_double: async function (data) {
      for (let [index, report] of data.entries()) {
        let ctx = document.querySelectorAll(`[id^="${report.id}"]`)
        let tmp_id = report.id.split('_')
        for (let dom of ctx) {
          let tmp = dom.id.split('_')
          if (tmp[0] === tmp_id[0] && tmp[1] === tmp_id[1]) {
            ctx = dom
          }
        }

        if (ctx) {
          await html2canvas(ctx, {
            dpi: 1000,
            scale: 1
          }).then((canvas) => {
            let img = canvas.toDataURL("image/png", 2);
            if (this.check_notes(data)) {
              this.add_image(img, 'a4_p2_desc', getPos(index), this.counters.from_top.current)
            } else {
              this.add_image(img, 'a4_p2', getPos(index), this.counters.from_top.current)
            }
            this.status = ((report.id).split('_')[1] / this.pageList.length * 100).toFixed(2)
          })
        }
      }

      function getPos(index) {
        switch (index) {
          case 0:
            return 10;
          case 1:
            return 150;
        }
      }
    },
    gen_report_triple: function (data) {
      data
    },
    add_image: function (img, size, x, y) {
      let width = 0
      let height = 0
      switch (size) {
        case 'a4_p1_desc':
          width = 277
          height = 100
          break
        case 'a4_p1':
          width = 277
          height = 160
          break
        case 'a4_p2_desc':
          width = 140
          height = 85
          break
        case 'a4_p2':
          width = 140
          height = 160
          break
        case 'a4_p3_desc':
          width = 140
          height = 85
          break
        case 'a4_p3_normal':
          width = 140
          height = 85
          break
        case 'a4_p3_tall':
          width = 140
          height = 160
          break
      }
      if (height > this.counters.from_top.graph_height) {
        this.counters.from_top.graph_height = height
      }
      this.pdf.addImage(img, 'PNG', x, y, width, height)
    },
    gen_pages: async function () {
      for (let section of this.report_data.section_list) {
        for (let page of section.groups) {
          await this.add_page_content(page, section)
          await this.addNewPage()
        }
      }
    },
    add_page_content: async function (page, section) {
      await this.gen_page_title(page, section)
      await this.gen_reports(page)
      await this.gen_notes(page)
      await this.gen_page_colontitle(page)
    },
    gen_notes: async function (page) {
      const pattern = page.reports.length
      if (this.check_notes(page.reports)) {
        this.counters.from_top.current += 5
        this.add_text(`Пояснительная записка: `, 10, this.counters.from_top.current, 'left', 'DinCyBd', 10)
        for (let [index, report] of page.reports.entries()) {
          if (report.description_note && report.description_note !== '') {
            switch (pattern) {
              case 1:
                this.gen_long_text(report.description_note, 277, 10, this.counters.from_top.current, 'left', 'DinCyRg', 10)
                break
              case 2:
                this.add_text(`График №${index+1}`, 10, this.counters.from_top.current, 'left', 'DinCyBd', 10)
                this.gen_long_text(report.description_note, 138, 10, this.counters.from_top.current, 'left', 'DinCyRg', 10)
                break
            }
          }
        }
      } else {
        console.log('Спец. записка отсутсвует!')
      }
    },
    gen_page_title: function (page, section) {
      this.add_text(`${section['name']}`, 10, this.counters.from_top.current, 'left', 'DinCyBd', 10)
    },
    gen_title_text: function () {
      let strokes = this.pdf.splitTextToSize(this.report_data['Объект'], 200)
      for (let i = 0; i < strokes.length; i++) {
        this.add_text(strokes[i], 150, 95+(i*8)+8, 'center', 'DinCyBd', 14)
      }
    },

    clearCounters: async function () {

    },
    save_pdf: async function () {
      setTimeout(async () => {
        this.now_printing = null
        let filename = this.converted.title.name+' ('+new Date().toISOString()+')'
        await this.pdf.save(filename+'.pdf')
        this.inProgress = false
      }, 8000)
    }
  }
}
</script>

<style scoped>
.contented {
  margin-top: 25px;
}
.charts_sheet {
  margin-left: 10px;
  background: #f8e7fd;
  margin-bottom: 10px;
  width: 1300px;
  aspect-ratio: 297 / 210;
}
.special-progress-text {
  font-size: 10px;
  text-shadow: 2px 0 2px #ffffff, 0 2px 2px #ffffff, -2px 0 2px #ffffff, 0 -2px 2px #ffffff;
}
</style>
